module.exports = __webpack_public_path__ + "static/media/full.2760bd84.png";